export const THEME_FONT_FAMILY = '"Camphor Pro", sans-serif';

export const THEME_SHAPE = {
  hasBorderRadius: true,
  radiusMd: "8px",
};

export const THEME_COLORS = {
  primary: "#143462",
  secondary: "#3f86cc",
  success: "#3f86cc",
  warning: "#f0a43f",
  danger: "#143462",
  text: "#143462",
  textHeading: "#143462",
  textSecondary: "#3f86cc",
  textTertiary: "#3f86cc",
  textPlaceholder: "#3f86cc",
  textDisabled: "#3f86cc",
  textInverse: "#ffffff",
  backgroundLayout: "#ffffff",
  backgroundContainer: "#ffffff",
  backgroundElevated: "#143462",
  backgroundOverlay: "rgba(20, 52, 98, 0.8)",
  border: "#3f86cc",
  menuItem: "#143462",
};

export const THEME_BUTTON_COLORS = {
  allBg: "#f0a43f",
  allHoverBg: "#f0a43f",
  allText: THEME_COLORS.primary,
  defaultBg: "#f0a43f",
  defaultText: THEME_COLORS.primary,
  defaultBorder: "#f0a43f",
  defaultHoverBg: "#f0a43f",
  defaultHoverText: THEME_COLORS.primary,
  defaultHoverBorder: "#f0a43f",
  primaryBg: "#f0a43f",
  primaryText: THEME_COLORS.primary,
  primaryBorder: "#f0a43f",
  primaryHoverBg: "#f0a43f",
  primaryHoverText: THEME_COLORS.primary,
  primaryHoverBorder: "#f0a43f",
  successBg: "#6a9134",
  successText: "#ffffff",
  successBorder: "#6a9134",
  warningBg: "#f0a43f",
  warningText: THEME_COLORS.primary,
  warningBorder: "#f0a43f",
  dangerBg: "#143462",
  dangerText: "#ffffff",
  dangerBorder: "#143462",
  ghostBg: "transparent",
  ghostText: "#143462",
  ghostBorder: "#3f86cc",
  hoverBg: "rgba(63, 134, 204, 0.15)",
  hoverBorder: "#3f86cc",
};

export const THEME_CARD_COLORS = {
  background: "#ffffff",
  border: "#3f86cc",
  companyText: "#f0a43f",
};

export const THEME_STATUS_COLORS = {
  pendingBg: "rgba(63, 134, 204, 0.15)",
  pendingText: "#3f86cc",
  inProgressBg: "rgba(240, 164, 63, 0.2)",
  inProgressText: "#f0a43f",
  completedBg: "rgba(106, 145, 52, 0.2)",
  completedText: "#6a9134",
  unknownBg: "#143462",
  unknownText: "#ffffff",
};

export const THEME_UI_COLORS = {
  modalBackground: "#ffffff",
  modalShadow: "0 20px 25px rgba(0, 0, 0, 0.3)",
  headerText: "#143462",
  headerTextInverse: "#143462",
  mutedText: "#3f86cc",
  menuBackground: "#ffffff",
  menuHoverBackground: "#3f86cc",
  menuShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
  inputBorder: "#3f86cc",
};

export const THEME_SHADOWS = {
  sm: "0 2px 4px rgba(0, 0, 0, 0.1)",
  md: "0 4px 6px rgba(0, 0, 0, 0.1)",
  lg: "0 8px 16px rgba(0, 0, 0, 0.2)",
  xl: "0 10px 15px rgba(0, 0, 0, 0.2)",
};

export const CSS_VARIABLES = {
  "--color-primary": THEME_COLORS.primary,
  "--color-secondary": THEME_COLORS.secondary,
  "--color-success": THEME_COLORS.success,
  "--color-warning": THEME_COLORS.warning,
  "--color-danger": THEME_COLORS.danger,
  "--color-text": THEME_COLORS.text,
  "--color-text-heading": THEME_COLORS.textHeading,
  "--color-text-secondary": THEME_COLORS.textSecondary,
  "--color-text-tertiary": THEME_COLORS.textTertiary,
  "--color-text-placeholder": THEME_COLORS.textPlaceholder,
  "--color-text-disabled": THEME_COLORS.textDisabled,
  "--color-text-inverse": THEME_COLORS.textInverse,
  "--color-bg-layout": THEME_COLORS.backgroundLayout,
  "--color-bg-container": THEME_COLORS.backgroundContainer,
  "--color-bg-elevated": THEME_COLORS.backgroundElevated,
  "--color-bg-overlay": THEME_COLORS.backgroundOverlay,
  "--color-border": THEME_COLORS.border,
  "--color-menu-item": THEME_COLORS.menuItem,
  "--color-card-bg": THEME_CARD_COLORS.background,
  "--color-card-border": THEME_CARD_COLORS.border,
  "--color-card-company-text": THEME_CARD_COLORS.companyText,
  "--color-status-pending-bg": THEME_STATUS_COLORS.pendingBg,
  "--color-status-pending-text": THEME_STATUS_COLORS.pendingText,
  "--color-status-in-progress-bg": THEME_STATUS_COLORS.inProgressBg,
  "--color-status-in-progress-text": THEME_STATUS_COLORS.inProgressText,
  "--color-status-completed-bg": THEME_STATUS_COLORS.completedBg,
  "--color-status-completed-text": THEME_STATUS_COLORS.completedText,
  "--color-status-unknown-bg": THEME_STATUS_COLORS.unknownBg,
  "--color-status-unknown-text": THEME_STATUS_COLORS.unknownText,
  "--color-button-default-bg": THEME_BUTTON_COLORS.defaultBg,
  "--color-button-default-hover-bg": THEME_BUTTON_COLORS.defaultHoverBg,
  "--color-button-default-text": THEME_BUTTON_COLORS.defaultText,
  "--color-button-default-hover-text": THEME_BUTTON_COLORS.defaultHoverText,
  "--color-button-default-border": THEME_BUTTON_COLORS.defaultBorder,
  "--color-button-default-hover-border": THEME_BUTTON_COLORS.defaultHoverBorder,
  "--color-button-primary-bg": THEME_BUTTON_COLORS.primaryBg,
  "--color-button-primary-hover-bg": THEME_BUTTON_COLORS.primaryHoverBg,
  "--color-button-primary-text": THEME_BUTTON_COLORS.primaryText,
  "--color-button-primary-hover-text": THEME_BUTTON_COLORS.primaryHoverText,
  "--color-button-primary-border": THEME_BUTTON_COLORS.primaryBorder,
  "--color-button-primary-hover-border": THEME_BUTTON_COLORS.primaryHoverBorder,
  "--color-button-success-bg": THEME_BUTTON_COLORS.successBg,
  "--color-button-success-text": THEME_BUTTON_COLORS.successText,
  "--color-button-success-border": THEME_BUTTON_COLORS.successBorder,
  "--color-button-warning-bg": THEME_BUTTON_COLORS.warningBg,
  "--color-button-warning-text": THEME_BUTTON_COLORS.warningText,
  "--color-button-warning-border": THEME_BUTTON_COLORS.warningBorder,
  "--color-button-danger-bg": THEME_BUTTON_COLORS.dangerBg,
  "--color-button-danger-text": THEME_BUTTON_COLORS.dangerText,
  "--color-button-danger-border": THEME_BUTTON_COLORS.dangerBorder,
  "--color-button-ghost-bg": THEME_BUTTON_COLORS.ghostBg,
  "--color-button-ghost-text": THEME_BUTTON_COLORS.ghostText,
  "--color-button-ghost-border": THEME_BUTTON_COLORS.ghostBorder,
  "--shadow-sm": THEME_SHADOWS.sm,
  "--shadow-md": THEME_SHADOWS.md,
  "--shadow-lg": THEME_SHADOWS.lg,
  "--shadow-xl": THEME_SHADOWS.xl,
  "--radius-md": THEME_SHAPE.hasBorderRadius ? THEME_SHAPE.radiusMd : "0px",
  "--radius-global": THEME_SHAPE.hasBorderRadius ? THEME_SHAPE.radiusMd : "0px",
};

export const applyThemeCssVariables = () => {
  if (typeof document === "undefined") return;

  const root = document.documentElement;
  root.setAttribute(
    "data-radius-mode",
    THEME_SHAPE.hasBorderRadius ? "rounded" : "flat",
  );

  Object.entries(CSS_VARIABLES).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
};
